import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=3e97df0e&scoped=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=3e97df0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e97df0e",
  null
  
)

export default component.exports